<div class="exterior mt-5">
  <ng-container *ngIf="main.length">
    <app-sedan
      [data]="main"
      *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['sedan']"
    ></app-sedan>
    <app-microbus
      [data]="main"
      *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['bus']"
    ></app-microbus>
    <app-truck-single-cabin
      [data]="main"
      *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['truckSingle']"
    ></app-truck-single-cabin>
    <app-truck-double-cabin
      [data]="main"
      *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['truckDouble']"
    ></app-truck-double-cabin>
    <app-suv [data]="main" *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['suv']"></app-suv>
    <app-cargo-van
      [data]="main"
      *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['cargo']"
    ></app-cargo-van>
  </ng-container>

  <loader [position]="{ absolute: true }" [active]="loaded"></loader>
</div>
